module.exports = __webpack_public_path__ + "static/productionS-747b8f08b5708e4fea11c02f6b41bed3.svg";